var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnenabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_538_227",
    transform: "matrix(0.01 0 0 0.0076 0 0.12)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_538_227",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqElEQVR4nO2dMW/UMBiGw8jOhAQFRhiZEIgfcbZVEDAhsSNVZbj6S0d+S/9FgZGx/4Kdo/ZBkKu0OSE1IHGxv4ufR/rGSPH35M05uTu7aQAAAAAAAAAAACpjtd/eW5uj18H4g2DkQx3lD9KYu8Vyr9FCWLTPo5Uv0UpXdRn/Obj2WTERXdPciMYfByu/ijfD6qjUi+C8pN5kF5JklG5AVFrBiM9+myIZMp6UhX+aTQifGfIvSfmUbTZV+pYQd6RWbnl/ciFrJ29KDzTuSK2tvJpcSJp/j51EMPI9GvlaQ4U01rFeWH+oYXZ11lRCtHI22gvjj6c/CYRcgRBlIEQZCFEGQpSBEGUgRBk7IYQHQ9ElhBKERK0XAgmR8hIQIuUbjxAp32yESPkGI0TKN3XXhQTjv0XrP9ZQ4WKsyoXwBZUgpBQ78eqEhAhCSkFClIEQZSBEGbMR8sO1D4Pzj6+r7kV7e+z4zr2/OXb8NiqdYzVC/ncg5+boUYYn7cnHsRUQMoCQHhKyAQkZICE9JGQDEjJAQnpIyAYkZIYJ4cFwi/D6fYYJmQsRIbpAiDIQogyEKAMhypiNkHMnb0dXanPjC4F1L9tbU68Wl86xGiF8QbVFEDJAQnp4ubgBCRkgIT0kZAMSMkBCekjIlhMSrJyMrtTm/Lux41eL9sHkq8VZOakmIXMhIkQXCFEGQpSBEGUgRBkIUQZClKFCCEuNi66lxtOeSxn+vdTNobIsxp82wGIzF/mrjNSjbn95p8lB2gCr9NUX1Zc/bXKRfoRASuT6dBj/Mzj/JJuQCylW2vJXoais4GTZ5CZtDZd2IyMp8kcyZFlk27xL0m5kaQOsqhNh016O/jT7bWqMzrV30zQvzb2rWVHO+sM05jT20v0HAAAAAAAAAABoMvMbePxK3y2x7+QAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnenabled);
export default __webpack_public_path__ + "static/media/Unenabled.14f6b9b4f6fce70edef2beb60d7051ad.svg";
export { ForwardRef as ReactComponent };